// shared-types/src/campaign/types.ts
// Campaign core types aligned with DB entities

export enum CampaignStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}

export interface Campaign {
    id: string
    accountId: string
    name: string
    description?: string | null
    startDate?: Date | null
    endDate?: Date | null
    status: CampaignStatus
    createdAt: Date
    updatedAt: Date
    deletedAt?: Date | null
}

export enum CampaignBudgetType {
    USAGE = 'usage',
    SPEND = 'spend',
    USAGE_BY_ATTRIBUTE = 'usage_by_attribute',
    SPEND_BY_ATTRIBUTE = 'spend_by_attribute',
}

export interface CampaignBudget {
    id: string
    accountId: string
    campaignId: string
    type: CampaignBudgetType
    limit?: number | null
    used: number
    attribute?: string | null
    createdAt: Date
    updatedAt: Date
    deletedAt?: Date | null
}

export interface CampaignBudgetUsage {
    id: string
    campaignBudgetId: string
    attributeValue: string
    used: number
    createdAt: Date
    updatedAt: Date
}

